import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; 
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'biometric',  
    loadChildren: () => import('./contexts/biometric/application/biometric.module').then(m => m.BiometricModule),
  },
  { path: 'iniciar-sesion',  
    loadChildren: () => import('./contexts/b2c/application/b2c.module').then(m => m.B2cModule),
  },
  { path: 'verificar-sesion',  
    loadChildren: () => import('./contexts/b2c/application/b2c-verification.module').then(m => m.B2cVerificationModule),
  },
  { path: 'login', loadChildren: () => import('./contexts/login/infrastructure/login.module').then(m => m.LoginModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
